import { render, staticRenderFns } from "./product-cart-container.vue?vue&type=template&id=4a38a1d4&scoped=true&lang=pug"
import script from "./product-cart-container.js?vue&type=script&lang=js&external"
export * from "./product-cart-container.js?vue&type=script&lang=js&external"
import style0 from "./product-cart-container.vue?vue&type=style&index=0&id=4a38a1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38a1d4",
  null
  
)

export default component.exports